import { EditEventContext } from "./EditEventContext";
import { EventsModal } from "./EventsModal";
import type { EventsModalProps } from "./EventsModal";

export const EventsV3 = ({ ...props }: EventsModalProps) => (
  <EditEventContext>
    <EventsModal {...props} />
  </EditEventContext>
);
